export default __webpack_public_path__ + "static/media/MZKZlogo.fc98e4b8.svg";